import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';

import * as S from './styles';
import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';
import { DataFormProps } from 'components/FormDynamicPageSelected/Forms/InputsProductGrid';
import WaitingForDataDynamicPage from 'components/WaitingForDataDynamicPage';
import ScheduleInfoDynamicPage from 'components/ScheduleInfoDynamicPage';
import CardProduct from 'components/CardProduct';
import { Product } from 'types/Product';

interface ProductGridProps {
	item: ItemDynamicPageInPhone;
}

export default function ProductGrid({ item }: ProductGridProps) {
	const { data } = item;

	const itemGrid: DataFormProps = data;

	//a lista é cortada para não ficar dificil de arrastar o item no drag and drop
	function returnList() {
		if (itemGrid.products.length === 2 || itemGrid.products.length < 2) {
			return (
				<S.gridProducts>
					{itemGrid.products.map((product) => (
						<CardProduct key={product.productId} product={product} /> //este componente já muda o card do produto de acordo com o tipo da loja
					))}
				</S.gridProducts>
			);
		} else {
			const itemGridCopy = structuredClone(itemGrid);
			const listCuted = itemGridCopy.products.slice(0, 2);
			return (
				<S.gridProducts>
					{listCuted.map((product: Product) => (
						<CardProduct key={product.productId} product={product} /> //este componente já muda o card do produto de acordo com o tipo da loja
					))}
				</S.gridProducts>
			);
		}
	}

	return Object.keys(item.data).length === 0 ? (
		<WaitingForDataDynamicPage />
	) : (
		<S.container>
			{(itemGrid.schedule_start !== '' || itemGrid.schedule_end !== '') && (
				<ScheduleInfoDynamicPage
					countdown={itemGrid.countdown}
					endDate={itemGrid.schedule_end}
					startDate={itemGrid.schedule_start}
				/>
			)}

			{itemGrid.products.length === 0 ? <p>Não há produtos</p> : returnList()}

			{itemGrid.products.length > 2 && (
				<S.infoSizeList>
					<S.icon>
						<FiAlertCircle />
					</S.icon>
					<p>Se a lista tiver mais produtos, aparecerá no app.</p>
				</S.infoSizeList>
			)}
		</S.container>
	);
}
